{
  "name": "wallet-front-new",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=development",
    "start:local": "ng serve --configuration=development --port 4201 --ssl true",
    "start:https": "ng serve --host 0.0.0.0 --ssl true",
    "build": "ng build && npm run sentry:sourcemaps",
    "build:dev": "ng build --configuration development",
    "assert:public-prerender": "node scripts/assert-public-prerender.mjs",
    "assert:aeo": "node scripts/assert-aeo.mjs",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:headless": "ng test --watch=false --karma-config karma.conf.cjs --browsers=ChromeHeadlessNoSandbox",
    "e2e": "playwright test",
    "e2e:smoke": "playwright test --grep @smoke --project=chromium",
    "e2e:smoke:all": "playwright test --grep @smoke",
    "e2e:funded": "playwright test --grep @funded --project=chromium",
    "e2e:webkit": "playwright test --project=webkit",
    "e2e:firefox": "playwright test --project=firefox",
    "e2e:mobile": "playwright test --project=mobile-safari",
    "e2e:install": "playwright install --with-deps chromium webkit firefox",
    "serve:ssr:wallet-front-new": "node dist/wallet-front-new/server/server.mjs",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org kaspacom --project wallet ./dist && sentry-cli sourcemaps upload --org kaspacom --project wallet ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/platform-server": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@angular/ssr": "^21.2.19",
    "@kaspacom/swap-sdk": "^1.1.26",
    "@kaspacom/ui-kit": "^0.3.31",
    "@kaspacom/wallet-messages": "^1.0.35",
    "@segment/analytics-next": "1.81.1",
    "@sentry/angular": "^10.31.0",
    "@sentry/cli": "^2.58.4",
    "angularx-qrcode": "^21.0.5",
    "crypto-js": "^4.2.0",
    "dexie": "^4.2.1",
    "ethers": "^6.13.5",
    "express": "^4.18.2",
    "graphemer": "^1.4.0",
    "html5-qrcode": "^2.3.8",
    "lodash": "^4.17.21",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@playwright/test": "^1.48.0",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.13",
    "@types/node": "^18.18.0",
    "@types/websocket": "^1.0.10",
    "dotenv": "^16.4.5",
    "i": "^0.3.7",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "npm": "^10.9.1",
    "prettier": "^3.5.3",
    "typescript": "~5.9.3"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "^4.45.1"
  }
}
